<template>
  <div class="category-content order-content">
    <div class="main-width">
      <div class="manage-center-content">
        <div class="manage-slide">
          <el-col>
            <el-menu
              default-active="1-1"
              class="el-menu-vertical-demo"
              :default-openeds="defaultOpen"
              @select="handleSelect"
            >
              <el-submenu index="1" class="persion_center">
                <template slot="title">
                  <i class="default-center-icon"></i>个人中心
                </template>

                <el-menu-item index="1-1">
                  <template slot="title">个人信息</template>
                </el-menu-item>
                <el-menu-item index="1-2">
                  <template slot="title">特别关注区域设置</template>
                </el-menu-item>
                <el-menu-item index="1-3">
                  <template slot="title">个性商城设置</template>
                </el-menu-item>
              </el-submenu>
            </el-menu>
          </el-col>
        </div>
        <div v-if="selectPage==1">
          <div class="manage-info">
            <img :src="imgAddress + info.logoPath" @error="error(4)" />
            <span>{{info.platformName}}</span>
            <!-- <span class="font">
              {{info.levelName}}
              <el-tooltip
                class="item"
                effect="dark"
                content="年度交易流水超过预定目标享受更优惠供应价格"
                placement="top"
              >
                <i class="el-icon-information"></i>
              </el-tooltip>
            </span> -->
            <span
              class="update-password-style"
              :class="{'display-none': !isModify}"
              @click="showModifyPw"
            >修改密码</span>
          </div>
          <div v-show="isModify">
            <div class="manage-config-info">
              <div class="manage-config-info-title">时间配置信息</div>
              <div class="manage-config-info-content">
                <div>已收货天数：{{info.toReceiveDays}}天</div>
                <div>已完成天数：{{info.toSuccessDays}}天</div>
              </div>
            </div>
            <div class="manage-config-info margin-bottom-15" v-show="isAddressModify">
              <div class="manage-config-info-title">收票地址信息</div>
              <div class="manage-config-info-content">
                <div>
                  地址：
                  <span>{{info.address}}</span>
                </div>
                <div>
                  电话：
                  <span>{{info.tel}}</span>
                </div>
                <span class="manage-modify-btn font-color-orange" @click="showUpdateAddress">修改</span>
              </div>
            </div>
            <div class="manage-config-info margin-bottom-15" v-show="!isAddressModify">
              <div class="manage-config-info-title">收票地址信息</div>
              <div class="manage-config-info-content">
                <div>
                  地址：
                  <span class="manage-config-info-input">
                    <input type="text" v-model="userAddress" />
                  </span>
                </div>
                <div>
                  电话：
                  <span class="manage-config-info-input">
                    <input type="tel" v-model="userMobil" />
                  </span>
                </div>
                <a class="manage-save-btn font-color-orange" @click="updateAddress">保存</a>
                <span class="manage-modify-btn" @click="cancelUpdateAddress">取消</span>
              </div>
            </div>
          </div>
          <div v-show="!isModify">
            <div class="manage-config-info margin-bottom-15">
              <div class="manage-config-info-title">修改密码</div>
              <div class="manage-config-info-content">
                <div>
                  <label>原始密码：</label>
                  <span class="manage-config-info-input modifyPw-input">
                    <input type="password" v-model="oldPw" @focus="hideTip" />
                  </span>
                  <span class="modifyPw-tip font-color-green">忘记密码请联系客服</span>
                  <div v-show="pwErrorTip" class="modifyPw-error-tip">
                    <label></label>
                    <span class="font-color-red">密码错误</span>
                  </div>
                </div>
                <div>
                  <label>新密码：</label>
                  <span class="manage-config-info-input modifyPw-input">
                    <input type="password" v-model="newPw" />
                  </span>
                  <span class="modifyPw-tip font-color-green">注：英文区分大小写</span>
                  <div v-show="newPwTip" class="modifyPw-error-tip">
                    <label></label>
                    <span class="font-color-red">密码至少6位</span>
                  </div>
                </div>
                <div>
                  <label>确认新密码：</label>
                  <span class="manage-config-info-input modifyPw-input">
                    <input type="password" v-model="confirmNewPw" />
                  </span>
                  <div v-show="confirmErrorTip" class="modifyPw-error-tip">
                    <label></label>
                    <span class="font-color-red">请与新密码保持一致</span>
                  </div>
                </div>
                <a class="manage-save-btn font-color-orange" @click="modifyPw">保存</a>
                <span class="manage-modify-btn" @click="cancelPwModify">取消</span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="selectPage==2">
          <div class="sp2-t1">
            特别关注区域设置
            <span>(如需设置请联系吉贡运营)</span>
          </div>
          <div class="sp2-t2">
            <div>
              <span class="infoicon"></span>温馨提示
            </div>
            <div>如果您对供货的覆盖面有要求，可以设置您的特别关注区域，设置后选货商城将不再提供无法达到您特别关注区域的货品。</div>
            <div>
              <div>例如:</div>
              <div>
                <div>a.货品必须能供货到新疆，那不到新疆的不会出现在您的视野内；</div>
                <div>b.货品必须能供货到内蒙，海南，云南，北京，那货物无法达到这几个区域中的任意区域时，该货品都不会展示。</div>
              </div>
            </div>
            <div>【注：如果您是做全国范围电商，可以允许部分商品对部分区域不供货。那请不要使用这个功能，系统将不设任何过滤】</div>
          </div>
          <div class="address">
            <!-- <el-cascader
              :options="options"
              :props="props"
              v-model="cascaderData"
              clearable="ture"
              collapse-tags
              placeholder="请选择特别关注区域"
              popper-class="popperClass"
              @change="casaderChange"
            ></el-cascader>-->
          </div>
          <div class="addressContent" style="margin-bottom:20px;">
            <div class="title">
              <div>已选的特别关注区域</div>
              <!-- <div>编辑完别忘了点“保存”哦</div> -->
            </div>
            <div class="content">
              <div class="empty_address" v-if="cascaderData2.length<=0">
                <div></div>
                <div>暂无特别关注区域！</div>
              </div>
              <ul v-else>
                <el-tag
                  v-for="(item,index) in cascaderData3"
                  :key="index"
                  class="item"
                  closable
                  @close="onClickTag(item[2],item[1])"
                >{{item[0].split('|')[1]+'/'+item[1].split('|')[1]+'/'+item[2].split('|')[1]}}</el-tag>
                <!--
              <li
                class="item"
                v-for="(item,index) in cascaderData"
                >{{item[0].split('|')[1]+'/'+item[1].split('|')[1]+'/'+item[2].split('|')[1]}}</li>-->
              </ul>
            </div>
          </div>
        </div>
        <div v-if="selectPage==3">
          <div class="third_block">
            <div>
              <div>商品展示类型设置</div>
              <div>请根据您的需要选择商城商品的展示类型，该设置将影响选货商城您看到的商品</div>
            </div>
            <div>
              <div class="radio-setting">
                <el-radio v-model="radioValue" label="0" :disabled="show_save_shop_style">带票&不带票全部展示</el-radio>
                <el-radio v-model="radioValue" label="1" :disabled="show_save_shop_style">仅展示带票商品</el-radio>
                <el-radio v-model="radioValue" label="2" :disabled="show_save_shop_style">仅展示不带票商品</el-radio>
              </div>
              <div
                v-if="show_save_shop_style"
                class="update_btn"
                @click="show_save_shop_style = false"
              >修改</div>
              <div v-else>
                <div class="a" @click="onSaveRadioValue">保存</div>
                <div @click="onRefreshRadioValue">取消</div>
              </div>
            </div>
          </div>
          <div class="third_block" style="margin-top:30px">
            <div>
              <div>服务类型设置</div>
              <div>如需更改服务类型，请联系吉贡的对接运营。</div>
            </div>
            <div>
              <div>
                <el-checkbox-group v-model="checkList" class="check-list">
                  <el-checkbox label="一件代发" :disabled="show_save_server_style"></el-checkbox>
                  <el-checkbox label="社群集采（运费线下另算）" :disabled="show_save_server_style"></el-checkbox>
                </el-checkbox-group>
              </div>
              <!-- <div
                v-if="show_save_server_style"
                class="update_btn"
                @click="show_save_server_style = false"
              >修改</div>
              <div v-else>
                <div class="a" @click="onSaveCheckList">保存</div>
                <div @click="onRefreshCheckList">取消</div>
              </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
.radio-setting/deep/ .is-checked {
  span {
    color: #f78d4c !important;
  }
}
.radio-setting/deep/.el-radio__input.is-checked .el-radio__inner {
  background-color: #f78d4c;
  border-color: #f78d4c;
}

.check-list/deep/.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #f78d4c;
}

.check-list/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #f78d4c;
  border-color: #f78d4c;
}
.radio-setting/deep/.el-radio__input.is-disabled .el-radio__inner {
  background-color: #f2f6fc;
  border-color: #dcdfe6;
}

.check-list/deep/.el-checkbox__input.is-disabled .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #f2f6fc;
  border-color: #dcdfe6;
}

.update_btn {
  cursor: pointer;
  font-size: 14px;
  font-family: PingFangSC;
  font-weight: 500;
  color: rgba(64, 158, 255, 1);
  line-height: 20px;
}
.empty_address {
  display: flex;

  flex-direction: row;
  justify-content: center;
  margin: 80px auto;
  align-items: center;
  > div:nth-child(1) {
    width: 80px;
    height: 80px;
    margin-right: 16px;
    background: url("../assets/img/location.png") no-repeat center center / 100%
      100%;
  }
  > div:nth-child(2) {
    font-size: 16px;
    font-family: PingFangSC;
    font-weight: 500;
    color: rgba(153, 153, 153, 1);
    line-height: 22px;
  }
}

.infoicon {
  margin-right: 4px;
  display: inline-block;
  width: 14px;
  height: 13px;
  background: url("../assets/img/infoicon.png") no-repeat center center/100%
    100%;
}
.third_block {
  width: 1050px;
  height: 150px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(246, 246, 246, 1);
  display: flex;
  flex-direction: column;
  > div:nth-child(1) {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 1050px;
    height: 50px;
    background: rgba(246, 246, 246, 1);
    > div:nth-child(1) {
      margin-left: 20px;

      height: 22px;
      font-size: 16px;
      font-family: PingFangSC;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      line-height: 22px;
    }
    > div:nth-child(2) {
      width: 490px;
      height: 20px;
      margin-left: 12px;
      font-size: 14px;
      font-family: PingFangSC;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      line-height: 20px;
    }
  }
  > div:nth-child(2) {
    display: flex;
    flex-direction: row;
    flex: 1;
    justify-items: center;
    align-items: center;

    > div:nth-child(1) {
      margin-left: 20px;
      /deep/.el-radio__label {
        margin-left: 12px;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 20px;
      }
    }
    > div:nth-child(2) {
      margin-left: auto;
      margin-right: 86px;
      display: flex;
      flex-direction: row;

      > div.a {
        color: #22ab39;
      }
      > div:nth-child(1) {
      }
      > div:nth-child(2) {
        margin-left: 30px;
      }
      > div {
        cursor: pointer;

        font-size: 14px;
        font-family: PingFangSC;
        font-weight: bold;
        color: rgba(153, 153, 153, 1);
        line-height: 20px;
      }
    }
  }
}
.address-button.grey {
  pointer-events: none;
  background: url("../assets/img/btn_grey.png") no-repeat center center/100%
    100%;
}
.address-button {
  width: 82px;
  height: 32px;
  font-size: 15px;
  display: flex;
  cursor: pointer;

  margin: 0 auto;
  margin-top: 88px;
  margin-bottom: 65px;
  justify-content: center;
  align-items: center;
  font-family: PingFangSC;
  font-weight: 500;
  background: url("../assets/img/green-btn.png") no-repeat center center/100%
    100%;
  color: rgba(255, 255, 255, 1);
  line-height: 21px;
}
.addressContent {
  width: 1050px;
  min-height: 301px;
  border: 1px solid rgba(238, 238, 238, 1);
  margin-top: 41px;
  .content {
    margin-top: 17px;
    margin-left: 6px;
    ul {
      display: flex;
      flex-direction: row;
      flex-flow: wrap;

      /deep/ .item {
        /deep/.el-tag__close {
          color: rgba(254, 169, 35, 1) !important;
        }
        /deep/ .el-tag__close:hover {
          color: #fff !important;
          background-color: rgba(254, 169, 35, 1) !important;
        }
        display: flex;

        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 400;
        color: rgba(254, 169, 35, 1) !important;
        line-height: 20px;
        justify-content: center;
        align-items: center;
        margin: 14px;
        background: rgba(255, 248, 237, 1);
        border-radius: 3px;
        border: 1px solid rgba(255, 234, 201, 1);
      }
    }
  }

  .title {
    display: flex;
    flex-direction: row;

    align-items: center;
    height: 40px;
    background: rgba(242, 242, 242, 1);
    padding-left: 20px;

    > div:nth-child(1) {
      font-size: 14px;
      font-family: PingFangSC;
      font-weight: 500;
      color: rgba(102, 102, 102, 1);
      line-height: 20px;
    }
    > div:nth-child(2) {
      margin-left: 8px;
      font-size: 12px;
      font-family: PingFangSC;
      font-weight: 400;
      color: rgba(255, 77, 94, 1);
      line-height: 18px;
    }
  }
}
.address {
  margin-top: 44px;
  // /deep/.el-cascader__tags {
  //   display: flex;
  //   flex-direction: row;
  //   flex-flow: nowrap;
  //   align-items: center;
  //   justify-content: center;
  // }
  /deep/ input {
    width: 350px;
    height: 40px !important;
    border-radius: 4px;
  }
}
.address {
  /deep/ .el-cascader .el-input .el-input__inner:focus,
  .el-cascader .el-input.is-focus .el-input__inner {
    border-color: rgba(254, 169, 35, 1) !important;

    border-radius: 2px;
  }
  /deep/.el-cascader .el-input .el-input__inner:focus,
  /deep/.el-cascader .el-input.is-focus .el-input__inner {
    border-color: rgba(254, 169, 35, 1) !important;
  }
}

.sp2-t1 {
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 22px;
  > span {
    font-size: 14px;
    font-family: PingFangSC;
    font-weight: 500;
    color: #ff6015;
  }
}

.sp2-t2 {
  margin-top: 12px;
  > div:nth-child(1) {
    font-size: 14px;
    font-family: PingFangSC;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    line-height: 20px;
    margin-top: 8px;
    margin-left: 28px;
  }
  > div:nth-child(2) {
    margin-left: 28px;
    margin-top: 10px;
    font-size: 14px;
    font-family: PingFangSC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 20px;
  }
  > div:nth-child(3) {
    display: flex;
    flex-direction: row;
    margin-left: 28px;
    margin-top: 10px;
    > div:nth-child(1) {
      margin-right: 10px;
      font-size: 14px;
      font-family: PingFangSC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 20px;
    }
    > div:nth-child(2) {
      display: flex;
      flex-direction: column;
      font-size: 14px;
      font-family: PingFangSC;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      line-height: 22px;

      > div:nth-child(1) {
      }
      > div:nth-child(2) {
      }
    }
  }
  > div:nth-child(4) {
    margin-left: 22px;
    margin-top: 10px;
    font-size: 14px;
    font-family: PingFangSC;
    font-weight: 500;
    color: rgba(255, 96, 21, 1);
    line-height: 20px;
  }
  width: 1050px;
  height: 152px;
  background: rgba(255, 249, 246, 1);
  border: 1px solid rgba(247, 141, 76, 0.5);
}
</style>
<script>
import store from "../store/index.js";
import {
  encryInfo,
  centerInfo,
  updatePw,
  updateData,
  imgAddress,
  carAdress,
  personalitySetting,
  // deleteSpecialArea,
  selectSpecialArea,
  // addSpecialArea,
  getPersonalitySetting
} from "../config/interface.js";
import { toast, imageError } from "../util/tool.js";
import { fetch } from "../config/fetch.js";
import router from "../router/index.js";
import "../util/md5.min.js";

export default {
  data() {
    return {
      show_save_shop_style: true,
      show_save_server_style: true,
      radioValue: 1,
      checkList: ["1", "2"],
      rawCascaderData: null,
      rawCascaderData2: null,
      cascaderData: null,
      cascaderData2: null,
      cascaderData3: null, //将所有的市区全部压缩成市区
      props: { multiple: true },
      options: null,
      selectPage: 1,
      defaultOpen: ["1"],
      userId: store.state.userId,
      info: {},
      isModify: true,
      isAddressModify: true,
      imgAddress: imgAddress,
      oldPw: "",
      newPw: "",
      confirmNewPw: "",
      newPwTip: false,
      pwErrorTip: false,
      confirmErrorTip: false,
      userAddress: "",
      userMobil: ""
    };
  },
  watch: {
    cascaderData2: function(value) {
      this.updateCascaderData3();
    },
    confirmNewPw: function(val) {
      if (val != this.newPw) {
        this.confirmErrorTip = true;
      } else {
        this.confirmErrorTip = false;
      }
    }
  },
  mounted() {
    this.init();
  },

  methods: {
    updateCascaderData3() {
      let cascaderData3 = JSON.parse(JSON.stringify(this.cascaderData2));
      for (let i = 0; i < this.options.length; i++) {
        //市
        for (let j = 0; j < this.options[i].children.length; j++) {
          let zoom = 0;
          // value: "140100|太原市"
          let t = this.options[i].children[j].value;
          for (let z = 0; z < this.cascaderData2.length; z++) {
            if (this.cascaderData2[z][1] == t) {
              zoom++;
            }
          }
          if (this.options[i].children[j].children.length == zoom) {
            // console.log("合并的市区", this.options[i].children[j].value);

            for (let f = cascaderData3.length - 1; f >= 0; f--) {
              if (cascaderData3[f][1] == this.options[i].children[j].value) {
                //this.cascaderData3
                cascaderData3.splice(f, 1);
              }
            }
            cascaderData3.push([
              this.options[i].value,
              this.options[i].children[j].value,
              "518|全部"
            ]);
          }

          this.cascaderData3 = cascaderData3;
        }
      }
      // console.log("原始数据", this.rawCascaderData);
      // console.log("原始数据1", this.cascaderData);
      // console.log("操作数据2", this.cascaderData2);
      // console.log("再次操作数据", this.cascaderData3);
    },
    deleteAddress() {
      this.deleteCascaderData = [];
      // console.log("123123", this.rawCascaderData);
      a: for (let i = 0; i < this.rawCascaderData.length; i++) {
        for (let j = 0; j < this.cascaderData2.length; j++) {
          // console.log(
          //   this.cascaderData2[j][2].indexOf(this.rawCascaderData[i][2])
          // );
          if (
            this.cascaderData2[j][2].indexOf(this.rawCascaderData[i][2]) != -1
          ) {
            continue a;
          }
        }
        this.deleteCascaderData.push(this.rawCascaderData[i]);
      }
      // console.log("删除的数据", this.deleteCascaderData);

      let params = [];
      for (let i = 0; i < this.deleteCascaderData.length; i++) {
        let obj = this.deleteCascaderData[i][3];
        params.push(obj);
      }
      if (params.length <= 0) {
        return;
      }
      fetch(deleteSpecialArea, {
        appId: this.$store.state.appId,
        userId: this.userId,
        appSpecialAreaIdList: params
      }).then(res => {
        // var str = "修改成功";
        // toast(str, 1, false);
      });
    },
    //保存地址
    onSaveAddress() {
      this.deleteAddress();

      let params = [];
      for (let i = 0; i < this.cascaderData2.length; i++) {
        let obj = {
          appId: this.$store.state.appId,
          proId: +this.cascaderData2[i][0].split("|")[0],
          proName: this.cascaderData2[i][0].split("|")[1],
          cityId: +this.cascaderData2[i][1].split("|")[0],
          cityName: this.cascaderData2[i][1].split("|")[1],
          areaId: +this.cascaderData2[i][2].split("|")[0],
          areaName: this.cascaderData2[i][2].split("|")[1]
        };
        params.push(obj);
      }
      if (params.length <= 0) {
        var str = "修改成功";
        toast(str, 1, false);
        setTimeout(() => {
          this.onSelectArea();
        }, 100);

        return;
      }
      fetch(addSpecialArea, {
        userId: this.userId,
        addData: params
      }).then(res => {
        var str = "修改成功";
        toast(str, 1, false);
        this.onSelectArea();
      });
    },
    onSaveCheckList() {
      if (this.checkList.length <= 0) {
        toast("至少选中一个", 2, false);
        return;
      }
      let cl;

      if (
        this.checkList.indexOf("社群集采（运费线下另算）") != -1 &&
        this.checkList.indexOf("一件代发") != -1
      ) {
        cl = 3;
      } else {
        if (this.checkList.indexOf("一件代发") != -1) {
          cl = 0;
        }

        if (this.checkList.indexOf("社群集采（运费线下另算）") != -1) {
          cl = 2;
        }
      }
      fetch(personalitySetting, {
        appId: this.$store.state.appId,
        userId: this.userId,
        goodsTaxDisplayType: +window.localStorage.getItem(
          "goodsTaxDisplayType"
        ),
        type: cl
      }).then(res => {
        if (res.code == 10000) {
          var str = "修改成功";
          toast(str, 1, false);
          this.init();
          this.show_save_server_style = true;
          //保存成功覆盖
          window.localStorage.setItem("type", cl);
        }
      });
    },
    onRefreshCheckList() {
      let type = localStorage.getItem("type");
      switch (+type) {
        case 0:
          this.checkList = ["一件代发"];
          break;
        case 3:
          this.checkList = ["一件代发", "社群集采（运费线下另算）"];
          break;
        case 2:
          this.checkList = ["社群集采（运费线下另算）"];
          break;
      }
      this.show_save_server_style = true;
    },
    onSaveRadioValue() {
      fetch(personalitySetting, {
        appId: this.$store.state.appId,
        userId: this.userId,
        goodsTaxDisplayType: +this.radioValue,
        type: +localStorage.getItem("type")
      }).then(res => {
        if (res.code == 10000) {
          var str = "修改成功";
          toast(str, 1, false);
          this.show_save_shop_style = true;
          //保存成功覆盖
          window.localStorage.setItem("goodsTaxDisplayType", this.radioValue);
        }
      });
    },
    onRefreshRadioValue() {
      this.show_save_shop_style = true;
      this.radioValue = window.localStorage.getItem("goodsTaxDisplayType");
    },
    handleSelect(e) {
      console.log(e);
      switch (e) {
        case "1-1":
          this.selectPage = 1;
          break;
        case "1-2":
          this.selectPage = 2;
          this.onSetArea();
          this.onSelectArea();
          break;
        case "1-3":
          //回显下.
          this.showDispalyType();
          break;
      }
    },
    showDispalyType() {
      fetch(getPersonalitySetting, {
        userId: this.userId,
        appId: this.$store.state.appId
      }).then(res => {
        // console.log("cailu", res);
        // console.log("cailu", localStorage.getItem("goodsTaxDisplayType"));
        // let goodsTaxDisplayType = localStorage.getItem("goodsTaxDisplayType");
        // let type = localStorage.getItem("type");
        let goodsTaxDisplayType = res.data.goodsTaxDisplayType;
        let type = res.data.type;
        //radioValue checkList
        this.radioValue = goodsTaxDisplayType + "";
        switch (+type) {
          case 0:
            this.checkList = ["一件代发"];
            break;
          case 3:
            this.checkList = ["一件代发", "社群集采（运费线下另算）"];
            break;
          case 2:
            this.checkList = ["社群集采（运费线下另算）"];
            break;
        }
        this.selectPage = 3;
      });
    },
    onClickTag(item, item2) {
      // console.log(item);
      item.split("|");
      for (let i = this.cascaderData2.length - 1; i >= 0; i--) {
        if (item == this.cascaderData2[i][2]) {
          console.log(item);
          this.$delete(this.cascaderData2, i);
        } else {
          if (item.split("|")[0] == "518") {
            //没有相同的,则表示全部
            if (item2 == this.cascaderData2[i][1]) {
              this.$delete(this.cascaderData2, i);
            }
          }
        }
      }
      //this.cascaderData = [];//
      this.cascaderData = null;
      //重新赋值, 给予更新
      setTimeout(() => {
        this.cascaderData = this.cascaderData2;
      }, 0);
      // console.log(this.cascaderData);
    },
    casaderChange(e) {
      // console.log(this.cascaderData);
      this.cascaderData2 = this.cascaderData;
    },
    //回显区域
    onSelectArea() {
      fetch(selectSpecialArea, {
        userId: this.userId,
        appId: this.$store.state.appId
      }).then(res => {
        if ((res.code = 10000)) {
          let arr = [];
          for (let i = 0; i < res.data.length; i++) {
            let v = res.data[i];
            let innerarr = [];

            innerarr.push(v["proId"] + "|" + v["proName"]);
            innerarr.push(v["cityId"] + "|" + v["cityName"]);
            innerarr.push(v["areaId"] + "|" + v["areaName"]);

            arr.push(innerarr);
          }
          let arr2 = [];
          for (let i = 0; i < res.data.length; i++) {
            let v = res.data[i];
            let innerarr = [];

            innerarr.push(v["proId"] + "|" + v["proName"]);
            innerarr.push(v["cityId"] + "|" + v["cityName"]);
            innerarr.push(v["areaId"] + "|" + v["areaName"]);
            innerarr.push(v["appSpecialAreaId"]);
            arr2.push(innerarr);
          }
          this.cascaderData2 = arr;
          this.cascaderData = arr;
          //原始数据
          this.rawCascaderData = JSON.parse(JSON.stringify(arr2));
          this.rawCascaderData2 = JSON.parse(JSON.stringify(arr));
        }
      });
    },
    onSetArea() {
      fetch(carAdress, {
        userId: this.userId,
        bodyId: this.$store.state.bodyId,
        appId: this.$store.state.appId,
      }).then(res => {
        let obj = {
          value: 2,
          label: "上海",
          children: [
            { value: 3, label: "普陀" },
            { value: 4, label: "黄埔" },
            { value: 5, label: "徐汇" }
          ]
        };

        let fn = function(res, area) {
          let r = {};
          r["value"] =
            (res["cityId"] || res["areaId"] || res["proId"]) +
            "|" +
            (res["cityName"] || res["areaName"] || res["proName"]);
          r["label"] = res["cityName"] || res["areaName"] || res["proName"];
          if (area) {
            let target = [];
            for (let i = 0; i < area.length; i++) {
              target.push(fn(area[i], area[i]["areas"]));
            }
            r["children"] = target;
          }
          return r;
        };
        let t = [];
        for (let i = 0; i < res.data.length; i++) {
          t.push(fn(res.data[i], res.data[i]["citys"]));
        }
        this.options = t;

        this.updateCascaderData3();
        // console.log("ressss", t);
      });
      // this.selectPage = 2;
    },
    error(num) {
      imageError(num, event);
    },
    init() {
      var data = {
        userId: this.userId,
        bodyId: store.state.bodyId,
        appId: this.$store.state.appId,
      };
      var url = centerInfo;
      fetch(url, data).then(res => {
        this.info = res.data;
        this.userAddress = this.info.address;
        this.userMobil = this.info.tel;
      });
    },
    showModifyPw() {
      this.isModify = !this.isModify;
    },
    modifyPw() {
      if (this.oldPw == "") {
        var str = "原始密码不能为空";
        toast(str, 2, false);
        return;
      }
      if (this.newPw == "") {
        var str = "新密码不能为空";
        toast(str, 2, false);
        return;
      }
      if (this.newPw.length < 6) {
        this.newPwTip = true;
        var str = "新密码不能少于6位";
        toast(str, 2, false);
        return;
      } else {
        this.newPwTip = false;
      }
      if (this.confirmNewPw == "") {
        var str = "确认密码不能为空";
        toast(str, 2, false);
        return;
      }
      if (this.newPw != this.confirmNewPw) {
        var str = "两次密码不一致";
        toast(str, 2, false);
        return;
      }
      var newPassword = md5(this.newPw + encryInfo);
      var oldPassword = md5(this.oldPw + encryInfo);
      var data = {
        newPassword: newPassword,
        oldPassword: oldPassword,
        userId: this.userId
      };
      var url = updatePw;
      fetch(url, data).then(res => {
        if (res.code == 10000) {
          var str = "修改成功";
          toast(str, 1, false);
          this.cancelPwModify();
        } else if (res.code == 20106) {
          var str = "密码错误";
          toast(str, 2, false);
          this.pwErrorTip = true;
        } else if (res.code == 20000) {
          var str = "服务器异常";
          toast(str, 2, false);
        }
      });
    },
    hideTip() {
      this.pwErrorTip = false;
    },
    cancelPwModify() {
      this.isModify = !this.isModify;
      this.oldPw = "";
      this.newPw = "";
      this.confirmNewPw = "";
      this.newPwTip = false;
      this.pwErrorTip = false;
      this.confirmErrorTip = false;
    },
    showUpdateAddress() {
      this.isAddressModify = !this.isAddressModify;
    },
    cancelUpdateAddress() {
      this.isAddressModify = !this.isAddressModify;
      this.userAddress = this.info.address;
      this.userMobil = this.info.tel;
    },
    updateAddress() {
      if (this.userAddress == "") {
        var str = "请输入地址";
        toast(str, 2, false);
        return;
      }
      if (this.userMobil == "") {
        var str = "请输入电话号码";
        toast(str, 2, false);
        return;
      }
      var data = {
        address: this.userAddress,
        apiUrl: "",
        billHeader: "",
        logoPath: "",
        platformName: "",
        taxNumber: "",
        tel: this.userMobil,
        toReceiveDays: "",
        to_success_days: "",
        userId: this.userId,
        appId: this.$store.state.appId,
      };
      var url = updateData;
      fetch(url, data).then(res => {
        // console.log(res);
        if (res.code == 10000) {
          var str = "修改成功";
          toast(str, 1, false);
          this.isAddressModify = !this.isAddressModify;
          this.init();
        } else {
          var str = "修改失败";
          toast(str, 2, false);
        }
      });
    }
  }
};
</script>




// WEBPACK FOOTER //
// Center.vue?c7e416ca